<template>
  <div class="transactions-amount-widget" :class="{ loading: statsLoading }">
    <stats-widget
      mode="small"
      :stats="stats"
      v-if="!statsLoading"
    ></stats-widget>
    <loader v-else></loader>
  </div>
</template>

<script>
import StatsWidget from '@vue-app/components/company/transactions/stats/StatsWidget.vue'
import Loader from '@vue-app/components/base/Loader.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'

export default {
  name: 'DashboardTransactionsAmountWidget',
  components: { Loader, StatsWidget },
  props: {
    company: {
      type: Object,
      required: true,
    },
    stats: [Object, Array],
    statsLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      companyStats: {},
    }
  },
  created() {},
  watch: {
    company() {},
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
.loader {
  width: 100px;
  height: 100px;
}
.transactions-amount-widget {
  &.loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  background: #ffffff;
  box-shadow: 0px 20px 30px rgba(225, 235, 253, 0.38);
  border-radius: 20px;
  padding: 22px;
  &__sort {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 44px;
    height: 44px;

    margin-right: 20px;
  }

  &__header {
    margin-bottom: 23px;
    display: flex;
    align-items: center;
  }

  &__title {
    font-weight: 500;
    font-size: pxToRem(16);
    line-height: pxToRem(20);
    color: $hint;
  }

  &__count {
    font-weight: 600;
    font-size: pxToRem(30);
    line-height: pxToRem(37);
    color: $h2;
  }

  &__bars {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  &__bar {
    width: calc(33.3333% - 13px);

    &--accepted & {
      &-fill {
        height: 70%;
        background-color: #9ae8a7;
      }
    }

    &--paid & {
      &-fill {
        height: 30%;
        background-color: #aed5f9;
      }
    }

    &--refund & {
      &-fill {
        height: 45%;
        background-color: #f9aeb3;
      }
    }

    &-item {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      height: 128px;
      margin-bottom: 12px;
    }

    &-fill {
      position: relative;
      bottom: 0;
      border-radius: 22px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 70%;
    }

    &-title {
      font-size: pxToRem(12);
      line-height: pxToRem(15);
      text-align: center;
      color: $h3;
    }

    &-count {
      font-weight: 600;
      font-size: pxToRem(11);
      line-height: pxToRem(13);
      color: #ffffff;
      text-align: center;
      margin-bottom: 4px;
    }

    &-amount {
      font-weight: bold;
      font-size: pxToRem(12);
      line-height: pxToRem(15);
      text-align: center;
      color: #ffffff;
    }
  }
}
</style>
